<template>
    <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog')" @keydown.esc="$emit('updateDialog')" width="750">
        <v-card>
            <v-card-title class="title-modal">
                <span class="headline">Confirmar Expedir orden de envío #{{ shipment_order?.code }}</span>
            </v-card-title>

            <v-card-text>
                <p>
                    ¿Esta seguro que desea expedir manualmente la orden de envío <b>#{{ shipment_order?.code }}</b>?
                </p>
                <p>
                    Los siguientes LPNs quedaran expedidos junto con la orden de envio.
                </p>
                <div>
                    <b>
                    <span v-for="(lpn) in lpns_to_ship" :key="lpn.id" style="margin-right: 10px;">
                        <v-chip                        
                        size="small"
                        color="black"
                        variant="outlined"
                        class="mt-2"
                        >
                        {{ lpn.lpn.code }}
                        </v-chip>
                    </span>
                    </b>
                    
                </div>
                <br/>
                <p style="color:red" v-if="lpns_to_unship && lpns_to_unship.length > 0">
                    Los siguientes LPNs quedaran desasociados de la orden de envio y podrá almacenarlos nuevamente.
                </p>
                <div>
                    <b>
                    <span v-for="(lpn) in lpns_to_unship" :key="lpn.id" style="margin-right: 10px;">
                        <v-chip                        
                        size="small"
                        color="red"
                        
                        class="mt-2"
                        >
                        {{ lpn.lpn.code }}
                        </v-chip>
                    </span>
                    </b>
                </div>
                
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="red darken-1" text @click="closeModal()"> No </v-btn>

                <v-btn color="green darken-1" text @click="expedir()" :loading="loading"> Si </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { lpnService } from "@/libs/ws/lpnService";
import { shipmentOrderService } from "@/libs/ws/shipmentOrderService";
import ValidMixin from "@/mixins/ValidMixin.vue";

export default {
    created() { },
    mixins: [ValidMixin],
    components: {},
    props: {
        dialog: Boolean,
        updateDialog: Function,
        shipment_order: Object,
        lpns_to_ship: Array,
        lpns_to_unship: Array,
        shipedSuccess: Function,
    },
    data: () => ({
        lpns: [],
        almacenes: [],
        loading: false,
    }),
    mounted() {

    },
    methods: {
        closeModal() {
            this.lpns = [];
            this.$emit("updateDialog");
        },
        expedir() {
            let params = {
                shipment_order_ids: [this.shipment_order.id],
                lpn_codes: this.lpns_to_ship.map(lpn_item => lpn_item.lpn.code)
            };

            this.loading = true;
            shipmentOrderService
                .shiped(params)
                .then((response) => {
                    if(response.status){
                        this.toast.success(response.msg);
                        this.$emit("updateDialog");
                        this.$emit("shipedSuccess");
                    } else {
                        this.toast.error(response.msg || "Error al expedir la orden de envío");
                    }
                })
                .catch((e) => {
                    this.toast.error(e.msg || "Error al expedir la orden de envío");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>